import React, { useEffect, useState, useRef } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from 'antd';
import {
  CompassBorderIcon,
  CompassArrowIcon,
  CompassArrowRedIcon,
} from '../../../icons.svg';

let dragging = false;
let angle = 0;
let direction = 0;

const RideTwisterCompass = (props) => {
  const {
    compassRotate,
    setCompassRotate,
    reset,
    isSetRotate,
    changeIsSetRotate,
  } = props;

  const ref = useRef(null);

  const [active, setActive] = useState(false);

  const resetHandler = () => {
    const box = document.querySelector('.compassArrowLayout');
    box.style.transform = `rotate(0deg)`;
    reset();
  };

  const setRotate = (direction) => {
    const box = document.querySelector('.compassArrowLayout');
    const angle = () => {
      if (direction < 180) {
        return -Math.abs(direction);
      }
      if (direction > 180) {
        return 360 - direction;
      }

      return direction;
    };
    box.style.transform = `rotate(${angle()}deg)`;
  };

  function mouseMove(e) {
    if (dragging) {
      const box = document.querySelector('.compassArrowLayout');
      const boxBoundingRect = box.getBoundingClientRect();
      const boxCenter = {
        x: boxBoundingRect.left + boxBoundingRect.width / 2,
        y: boxBoundingRect.top + boxBoundingRect.height / 2,
      };

      angle =
        Math.atan2(e.pageX - boxCenter.x, -(e.pageY - boxCenter.y)) *
        (180 / Math.PI);

      if (angle < 0) {
        direction = Math.abs(angle);
      }
      if (angle > 0) {
        direction = 360 - angle;
      }

      box.style.transform = `rotate(${angle}deg)`;
    }
  }

  function mouseUp() {
    dragging = false;
    setCompassRotate(direction);
  }

  function mouseDown() {
    dragging = true;
    changeIsSetRotate(true);
  }

  const onMouseEnter = () => {
    ref.current.addEventListener('mousemove', mouseMove);
    ref.current.addEventListener('mousedown', mouseDown);
    ref.current.addEventListener('mouseup', mouseUp);
  };

  const onMouseLeave = () => {
    ref.current.removeEventListener('mousemove', mouseMove);
    ref.current.removeEventListener('mousedown', mouseDown);
    ref.current.removeEventListener('mouseup', mouseUp);
  };

  useEffect(() => {
    if (active) {
      onMouseEnter();
    } else {
      onMouseLeave();
    }
  }, [active]);

  useEffect(() => {
    if (compassRotate > 0) {
      setRotate(compassRotate);
    }
    return () => {
      onMouseLeave();
    };
  }, []);

  return (
    <div className="compassLayout">
      <div className="info">
        <div className="title">
          <FormattedMessage
            id="Set direction of the tour"
            defaultMessage="Set direction of the tour"
          />
        </div>
        <div className="mode">
          <FormattedMessage
            id="Tour direction"
            defaultMessage="Tour direction"
          />
          <br />
          <span>
            {isSetRotate ? (
              <FormattedMessage id="Fixed" defaultMessage="Fixed" />
            ) : (
              <FormattedMessage id="Random" defaultMessage="Random" />
            )}
          </span>
        </div>
        <div className="clear">
          <FormattedMessage
            id="Click on the arrow to set a fixed direction"
            defaultMessage="Click on the arrow to set a fixed direction"
          />
          <br />
          <Button
            size="small"
            disabled={!isSetRotate}
            type={isSetRotate ? 'primary' : 'default'}
            onClick={() => resetHandler()}
          >
            <span>
              <FormattedMessage id="Clear" defaultMessage="Clear" />
            </span>
          </Button>
        </div>
      </div>
      <div
        className={!isSetRotate ? 'rtCompass' : 'rtCompass active'}
        id="rtCompass"
        onMouseEnter={() => setActive(true)}
        onMouseLeave={() => setActive(false)}
        ref={ref}
      >
        <div className="label labelN">N</div>
        <div className="label labelW">W</div>
        <div className="label labelE">E</div>
        <div className="label labelS">S</div>
        <CompassBorderIcon width={90} height={90} className="rtCompassBorder" />
        <div className="compassArrowLayout">
          <div className="center" id="center" />
          <CompassArrowIcon width={50} height={50} className="rtCompassArrow" />
          <CompassArrowRedIcon
            width={50}
            height={50}
            className={
              isSetRotate ? 'rtCompassRedArrow active' : 'rtCompassRedArrow'
            }
          />
        </div>
      </div>
    </div>
  );
};

export default RideTwisterCompass;
